import { DocumentSnapshot, Timestamp, GeoPoint } from "firebase/firestore"
export { DocumentSnapshot, Timestamp, GeoPoint }

export class logger {
    static log = (...args: any[]) => {
        console.log(args)
    }

    static debug = (...args: any[]) => {
        console.log(args)
    }

    static warn = (...args: any[]) => {
        console.warn(args)
    }

    static error = (...args: any[]) => {
        console.error(args)
    }
}
